// import history from '../history';
import _ from 'lodash';
import {
    queryCoveragesByMember,
    updateCoverageSelectedOption,
    queryCoveragesHistoryByMember,
} from '../api/selectiongql';
import {
    COVERAGES_LOAD,
    COVERAGES_UPDATE,
    COVERAGES_HISTORY_LOAD,
} from './types';

export const handleUpdateCoverageOption = (
    {
        coverageId,
        optionId,
        member,
        skipUpdateData
    }, 
    errorCallback, 
    successCallback,
) => async (dispatch, getState) => {
    const state = getState();
    const {token, family} = state.config;
    const data = await updateCoverageSelectedOption({
        coverageId,
        optionId,
        token,
    });
    // console.log('data->', data);
    // const memberNewCoverages = mergeCoverageData(data, member, {});
    if (data instanceof Error) {
        if (errorCallback) errorCallback(data);
    } else if (skipUpdateData) {
            successCallback();
    } else {
        // Renew all members (in family) coverages result here
        // console.log("Renew all members (in family) coverages result here", member)
        let products = {};
        let coverages = {};
        // get coreMember coverage
        const coreMemberCoverages = await queryCoveragesByMember({
            member: family.coreMember.id, 
            token
        });
        // console.log("coreMemberCoverages", coreMemberCoverages)
        if (coreMemberCoverages instanceof Error && errorCallback) errorCallback(data);
        products = mergeProductData(coreMemberCoverages, products);
        coverages = mergeCoverageData(coreMemberCoverages, family.coreMember.id, coverages);
        for (let i = 0; i < family.dependents.length; i++) {
            const dep = family.dependents[i];
            const depCoverages = await queryCoveragesByMember({
                member: dep.id, 
                token
            });
            // console.log("depCoverages", depCoverages)
            if (depCoverages instanceof Error && errorCallback) errorCallback(data);
            // console.log('depCoverages->', depCoverages);
            products = mergeProductData(depCoverages, products);
            coverages = mergeCoverageData(depCoverages, dep.id, coverages);
        }
        if (successCallback) successCallback();
        dispatch({
            type: COVERAGES_LOAD,
            payload: {
                products,
                coverages,
                loaded: true,
            },
        });
        // //  Get member new coverages result here
        // let memberNewCoverages = await queryCoveragesByMember({
        //     member,
        //     token,
        // });
        // if (memberNewCoverages instanceof Error) {
        //     if (errorCallback) errorCallback(memberNewCoverages);
        // } else {
        //     memberNewCoverages = mergeCoverageData(memberNewCoverages, member, {});
        //     // Update Various UI components
        //     if (successCallback) successCallback();
        //     dispatch({
        //         type: COVERAGES_UPDATE,
        //         payload: {
        //             member,
        //             coverages: memberNewCoverages,
        //         },
        //     });
        // }
    }
};

export const handleGetCoverages = ({}, callback) => async (dispatch, getState) => {
    const state = getState();
    const {family, token} = state.config;
    let products = {};
    let coverages = {};
    // get coreMember coverage
    const coreMemberCoverages = await queryCoveragesByMember({
        member: family.coreMember.id, 
        token
    });
    products = mergeProductData(coreMemberCoverages, products);
    coverages = mergeCoverageData(coreMemberCoverages, family.coreMember.id, coverages);
    for (let i = 0; i < family.dependents.length; i++) {
        const dep = family.dependents[i];
        const depCoverages = await queryCoveragesByMember({
            member: dep.id, 
            token
        });
        // console.log('depCoverages->', depCoverages);
        products = mergeProductData(depCoverages, products);
        coverages = mergeCoverageData(depCoverages, dep.id, coverages);
    }
    // console.log('products->', products);
    // console.log('coverages->', coverages);
    // dispatch event - loading completed
    dispatch({
        type: COVERAGES_LOAD,
        payload: {
            products,
            coverages,
            loaded: true,
        },
    });
};

export const handleGetCoveragesHistory = ({}, callback) => async (dispatch, getState) => {
    const state = getState();
    const {family, token} = state.config;
    let products = {};
    let benefitPeriods = {};
    let coverages = {};
    // get coreMember coverage
    const coreMemberCoverages = await queryCoveragesHistoryByMember({
        member: family.coreMember.id, 
        token
    });
    benefitPeriods = mergeHistoricalBenefitPeriods(coreMemberCoverages, benefitPeriods);

    // get products and coverages by benefitPeriod
    _.mapKeys(benefitPeriods, (bp, k) => {
        // console.log('bp->', bp);
        const c = _.filter(coreMemberCoverages, (_c) => _c.benefitPeriod.id === k);
        // console.log('c->', c);
        const newC = mergeHistoricalCoverageData(c, family.coreMember.id, {});
        const newP = mergeProductData(c, {});

        products[k] = newP;
        coverages[k] = newC;
    });

    for (let i = 0; i < family.dependents.length; i++) {
        const dep = family.dependents[i];
        const depCoverages = await queryCoveragesHistoryByMember({
            member: dep.id, 
            token
        });
        benefitPeriods = mergeHistoricalBenefitPeriods(depCoverages, benefitPeriods);

        _.mapKeys(benefitPeriods, (bp, k) => {
            const c = _.filter(depCoverages, (_c) => _c.benefitPeriod.id === k);

            let newC = (coverages[k]) ? coverages[k] : {};
            let newP = (products[k]) ? products[k] : {};
            
            newC = mergeHistoricalCoverageData(c, dep.id, newC);
            newP = mergeProductData(c, newP);
            
            products[k] = newP;
            coverages[k] = newC;
        });
    }

    // console.log('benefitPeriods->', JSON.stringify(benefitPeriods));
    // console.log('coverages->', JSON.stringify(coverages));
    // console.log('products->', JSON.stringify(products));

    dispatch({
        type: COVERAGES_HISTORY_LOAD,
        payload: {
            products,
            benefitPeriods,
            coverages,
            loaded: true,
        },
    })
};

const mergeHistoricalBenefitPeriods = (coverages, benefitPeriods) => {
    let newBenefitPeriods = _.assign({}, benefitPeriods);
    for (let i = 0; i < coverages.length; i++) {
        const coverage = coverages[i];
        if (!newBenefitPeriods[coverage.benefitPeriod.id]) {
            newBenefitPeriods[coverage.benefitPeriod.id] = coverage.benefitPeriod;
        }
    }
    return newBenefitPeriods;
};

const mergeHistoricalCoverageData = (coverages, member, coverageData) => {
    let newCoverageData = _.assign({}, coverageData);
    let memberCoverageByProduct = {};
    for (let i = 0; i < coverages.length; i++) {
        const coverage = coverages[i];

        if (memberCoverageByProduct[coverage.product.id]) {
            memberCoverageByProduct[coverage.product.id] = [
                ...memberCoverageByProduct[coverage.product.id],
                coverage,
            ];
        } else {
            memberCoverageByProduct[coverage.product.id] = [coverage];
        }
    }
    newCoverageData[member] = memberCoverageByProduct;
    return newCoverageData;
};

const mergeProductData = (coverages, productData) => {
    let newProductData = _.assign({}, productData);
    for (let i = 0; i < coverages.length; i++) {
        const coverage = coverages[i];
        if (!newProductData[coverage.product.id]) {
            newProductData[coverage.product.id] = coverage.product;
        }
    }
    return newProductData;
};

const mergeCoverageData = (coverages, member, coverageData) => {
    let newCoverageData = _.assign({}, coverageData);
    let memberCoverageByProduct = {};
    for (let i = 0; i < coverages.length; i++) {
        const coverage = coverages[i];
        memberCoverageByProduct[coverage.product.id] = coverage;
    }
    newCoverageData[member] = memberCoverageByProduct;
    return newCoverageData;
};